import React, { useEffect, useState } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import { getPermissions } from "../../rbac/hasAccess";
import { Autocomplete, Box, Button, TextField } from "@mui/material";
import { DateInput } from "../../../utils/commonComponent/Custom/custominput";
import { AddButton } from "../../../utils/commonComponent/Custom/Button";
import { getFormattedDates } from "../../../utils/utils";
import { certQuery } from "../../certificates/certQuery";
// import { dsQuery } from "../../datasheet/query";
import ExcelDownload from "../../../utils/commonComponent/ExcelDownload";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import moment from "moment";

const headers = [
  { key: "customerName", label: "Client" },
  { key: "labReferenceNo", label: "Lab Reference No." },
  { key: "jobNo", label: "Job No." },
  { key: "Total_Test", label: "Total Test" },
  { key: "Tested", label: "Tested" },
  { key: "Approved", label: "Approved" },
  { key: "Authorised", label: "Authorised" },
  { key: "Pending", label: "Pending" },
];
let notNeededColumn = ["id"];

const ProgressReport = (props) => {
  const permissions = getPermissions(props.moduleId);
  const [labRefOptions, setLabRefOptions] = useState([]);
  const [selectedLabs, setSelectedLabs] = useState([]);
  const [progressReport, setProgressReport] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [searched, setSearched] = useState(false);
  const [secondSheet, setsecondSheet] = useState([]);
  const [thirdSheet, setthirdSheet] = useState([]);
  // Pagination states
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalRecords, setTotalRecords] = useState(0);
  // Pagination logic
  const totalPages = Math.ceil(totalRecords / rowsPerPage);
  const handleChangePage = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  useEffect(() => {
    const fetchLabRefs = async () => {
      try {
        const query = `SELECT DISTINCT inward.id AS inward_id, inward.labReferenceNo AS inward_labReferenceNo FROM inward WHERE inward.labReferenceNo IS NOT NULL AND inward.labReferenceNo != '-'  AND inward.status != -1 ORDER BY inward.id DESC;`;
        const result = await fetchQuery(query);
        const refs = result
          .filter((row) => row.inward_labReferenceNo?.trim())
          .map((row) => ({
            id: row.inward_id,
            label: row.inward_labReferenceNo.trim(),
          }));
        setLabRefOptions(refs);
      } catch (error) {
        console.error("Error fetching lab references:", error);
      }
    };

    fetchLabRefs();
  }, []);

  const handleSearch = async () => {
    try {
      const selectedRefs = selectedLabs.map((lab) => lab.label);
      const selectedRefsSql = selectedRefs.map((ref) => `'${ref}'`).join(",");
      const offset = currentPage * rowsPerPage;

      // --- progress Query ---
      let progressQuery = `SELECT inward.customerName AS customerName, inward.labReferenceNo AS labReferenceNo, jobRegister.jobNumber as jobNo, COUNT(certificate.id) AS Total_Test,
        SUM(CASE WHEN observationSheet.testedBy IS NOT NULL AND observationSheet.testedBy != '' THEN 1 ELSE 0 END) AS Tested,
        SUM(CASE WHEN certificate.preparedBy IS NOT NULL AND certificate.preparedBy != '' THEN 1 ELSE 0 END) AS Prepared,
        SUM(CASE WHEN certificate.reviewedBy IS NOT NULL AND certificate.reviewedBy != '' THEN 1 ELSE 0 END) AS Reviewed,
        SUM(CASE WHEN certificate.authorizedBy IS NOT NULL AND certificate.authorizedBy != '' THEN 1 ELSE 0 END) AS Authorized,
        GREATEST(
          COUNT(certificate.id)
          - (
              COALESCE(SUM(CASE WHEN observationSheet.testedBy IS NOT NULL AND observationSheet.testedBy != '' THEN 1 ELSE 0 END),0)
            + COALESCE(SUM(CASE WHEN certificate.preparedBy IS NOT NULL AND certificate.preparedBy != '' THEN 1 ELSE 0 END),0)
            + COALESCE(SUM(CASE WHEN certificate.reviewedBy IS NOT NULL AND certificate.reviewedBy != '' THEN 1 ELSE 0 END),0)
            + COALESCE(SUM(CASE WHEN certificate.authorizedBy IS NOT NULL AND certificate.authorizedBy != '' THEN 1 ELSE 0 END),0)
            ),
          0
        ) AS Pending
      FROM certificate LEFT JOIN observationSheet ON observationSheet.certificateId = certificate.id LEFT JOIN inwardTests ON observationSheet.inwardTestId = inwardTests.id LEFT JOIN inward ON inward.id = inwardTests.inwardId LEFT JOIN jobRegister ON inward.jobId = jobRegister.id WHERE certificate.status != -1`;

      if (selectedRefsSql) {
        progressQuery += ` AND inward.labReferenceNo IN (${selectedRefsSql})`;
      }

      if (fromDate && toDate) {
        const { from, to } = getFormattedDates(fromDate, toDate);
        progressQuery += ` AND DATE(observationSheet.startTestingDate) BETWEEN '${from}' AND '${to}'`;
      }

      progressQuery += ` GROUP BY inward.labReferenceNo, inward.customerName ORDER BY inward.labReferenceNo DESC`;

      const progressDataQuery = `${progressQuery} LIMIT ${rowsPerPage} OFFSET ${offset};`;
      const countQuery = `SELECT COUNT(*) AS total FROM (${progressQuery}) AS subquery;`;

      // --- Second Sheet Query (Detailed) ---
      let detailQuery = `${certQuery} WHERE 1=1 AND certificate.status != -1`;
      if (selectedRefsSql) {
        detailQuery += ` AND inward.labReferenceNo IN (${selectedRefsSql})`;
      }
      if (fromDate && toDate) {
        const { from, to } = getFormattedDates(fromDate, toDate);
        detailQuery += ` AND DATE(observationSheet.startTestingDate) BETWEEN '${from}' AND '${to}'`;
      }
      detailQuery += ` ORDER BY certificate.id DESC;`;

      // --- Fetch All Queries Together ---
      const [progressData, countData, detailedData] = await Promise.all([
        fetchQuery(progressDataQuery),
        fetchQuery(countQuery),
        fetchQuery(detailQuery),
      ]);

      // --- Format detailed data (second sheet) ---
      const formattedSecondSheet = (detailedData || []).map((row) => ({
        customer_Name: row.inward_customerName || "-",
        Material: row.materialScope_MaterialName || "-",
        Test: row.materialTestings_testName || "-",
        Job_No: row.jobRegister_jobNumber || "-",
        Lab_Ref_No: row.inward_labReferenceNo || "-",
        Test_No: row.observationSheet_testNumber || "-",
        ULR_No: row.certificate_ulrNumber || "-",
        Report_No: row.certificate_reportNumber || "-",
        Test_Date: row.observationSheet_startTestingDate
          ? moment(row.observationSheet_startTestingDate).format("DD/MM/YYYY")
          : "-",
        Tested_By: row.testedBy_userName || "-",
        Prepared_By: row.preparedBy_userName || "-",
        Reviewed_By: row.reviewedBy_userName || "-",
        Authorized_By: row.authorizedBy_userName || "-",
      }));

      // ---  Build Third Sheet (grouped by Customer + Lab Ref + Test) ---
      const thirdSheetMap = {};

      (formattedSecondSheet || []).forEach((row) => {
        const key = `${row.customer_Name}|${row.Lab_Ref_No}|${row.Test}`;
        if (!thirdSheetMap[key]) {
          thirdSheetMap[key] = {
            customer_Name: row.customer_Name,
            Lab_Ref_No: row.Lab_Ref_No,
            Test: row.Test,
            Quantity: 0,
          };
        }
        thirdSheetMap[key].Quantity += 1;
      });

      const formattedThirdSheet = Object.values(thirdSheetMap);


      setProgressReport(progressData || []);
      setsecondSheet(formattedSecondSheet);
      setthirdSheet(formattedThirdSheet);
      setTotalRecords(countData?.[0]?.total || 0);
      setSearched(true);
    } catch (error) {
      console.error("Error fetching summary report:", error);
    }
  };

  const clearSearch = () => {
    setProgressReport([]);
    setTotalRecords(0);
    setSearched(false);
    setFromDate(null);
    setToDate(null);
    setSelectedLabs([]);
  };

  const isDisabled = !((fromDate && toDate) || selectedLabs.length > 0);

  if (!permissions?.view) return;

  return (
    <div>
      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap" sx={{ width: "100%", p: 1 }}>
        <Box flexBasis="30%">
          <Autocomplete
            multiple
            size="small"
            options={[{ id: "all", label: "Select All" }, ...labRefOptions]}
            value={selectedLabs}
            onChange={(_, value) => {
              const isSelectAllChosen = value.some((v) => v.id === "all");
              if (isSelectAllChosen) {
                // If all already selected, then clear all
                if (selectedLabs.length === labRefOptions.length) {
                  setSelectedLabs([]);
                } else {
                  // Otherwise select all (exclude the "Select All" option itself)
                  setSelectedLabs(labRefOptions);
                }
              } else {
                // Regular multi-selection
                setSelectedLabs(value);
              }
              setSearched(false);
            }}
            getOptionLabel={(option) => option.label || ""}
            isOptionEqualToValue={(option, value) =>
              String(option?.id) === String(value?.id)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Lab Reference No"
                placeholder="Select lab refs"
                size="small"
              />
            )}
            limitTags={1}
            fullWidth
          />
        </Box>

        <Box flexBasis="10%">
          <DateInput
            label="From Date"
            value={fromDate}
            onChange={(d) => {
              setFromDate(d);
              setSearched(false);
            }}
          />
        </Box>

        <Box flexBasis="10%">
          <DateInput
            label="To Date"
            value={toDate}
            onChange={(d) => {
              setToDate(d);
              setSearched(false);
            }}
          />
        </Box>

        <Box flexBasis="10%">
          <Button
            variant="contained"
            color={searched ? "error" : "primary"}
            disabled={isDisabled}
            onClick={() => (searched ? clearSearch() : handleSearch())}
            fullWidth
            sx={{
              textTransform: "none",
              height: "40px",
            }}
          >
            Search
          </Button>
        </Box>

        {progressReport?.length > 0 && (
          <Box flexBasis="30%" display="flex" gap={1}>
            {permissions?.excelDownload && (
              <ExcelDownload
                notNeededColumn={notNeededColumn}
                finalData={progressReport}
                headers={headers}
                secondTable={secondSheet}
                thirdTable={thirdSheet}
              />
            )}
          </Box>
        )}
      </Box>

      <div className="w-full border rounded-md shadow">
        {/* Table Container */}
        <div className="w-full border rounded-md shadow">
          <div className="overflow-y-auto h-auto max-h-[400px]">
            <table className="min-w-full text-sm text-left text-gray-700">
              <thead className="sticky top-0 bg-blue-50 text-xs uppercase font-medium text-gray-600 z-10">
                <tr>
                  <th className="px-4 py-3 text-center">Sr. No.</th>
                  <th className="px-4 py-3 text-center">Customer Name </th>
                  <th className="px-4 py-3 text-center">Lab Reference No.</th>
                  <th className="px-4 py-3 text-center">Job No.</th>
                  <th className="px-4 py-3 text-center">Total Tests</th>
                  <th className="px-4 py-3 text-center">Tested</th>
                  <th className="px-4 py-3 text-center">Reviewed</th>
                  <th className="px-4 py-3 text-center">Authorized</th>
                  <th className="px-4 py-3 text-center">Pending</th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-200">
                {progressReport.map((row, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-2 text-center">
                      {currentPage * rowsPerPage + index + 1}
                    </td>
                    <td className="px-4 py-2 text-center">{row.customerName}</td>
                    <td className="px-4 py-2 text-center">{row.labReferenceNo}</td>
                    <td className="px-4 py-2 text-center">{row.jobNo}</td>
                    <td className="px-4 py-2 text-center">{row.Total_Test}</td>
                    <td className="px-4 py-2 text-center">{row.Tested}</td>
                    <td className="px-4 py-2 text-center">{row.Reviewed}</td>
                    <td className="px-4 py-2 text-center">{row.Authorized}</td>
                    <td className="px-4 py-2 text-center">{row.Pending}</td>
                  </tr>
                ))}

                {progressReport.length === 0 && (
                  <tr>
                    <td colSpan={7} className="text-center py-4 text-gray-500">
                      No data available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between px-4 py-2 bg-blue-50 text-sm border-t">
          <div className="flex items-center gap-2">
            <span>Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              className="border rounded px-2 py-1 text-sm"
            >
              {[30, 50, 100].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-gray-600">
              {totalRecords === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  totalRecords
                )} of ${totalRecords}`}
            </span>
            <button
              onClick={() => handleChangePage(0)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage - 1)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage + 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(totalPages - 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-1 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressReport;
